import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetDynamicTableDataMutation } from 'store/features/api/graphSlice';
import { buildRoomId, toTrimmedString } from 'static-solutions/24155/console-solution/lead-workbench/utils/workbench';

const useIdentityCaseChatMessages = ({ open, itemId, processCode }) => {
	const [getDynamicChatData, { isLoading }] = useGetDynamicTableDataMutation();
	const [chatMessages, setChatMessages] = useState([]);

	const loadChatMessages = useCallback(async () => {
		const safeItemId = toTrimmedString(itemId);
		const safeProcessCode = toTrimmedString(processCode);
		if (!safeItemId || !safeProcessCode) return;

		const response = await getDynamicChatData({
			url: '/dynamic-group-chat/get-all',
			data: {
				processCode: safeProcessCode,
				itemId: safeItemId,
				roomId: buildRoomId({ processCode: safeProcessCode, itemId: safeItemId }),
				page: 0,
				size: 60,
			},
		}).unwrap();

		const rows = Array.isArray(response?.chats) ? response.chats.slice().reverse() : [];
		setChatMessages(rows);
	}, [getDynamicChatData, itemId, processCode]);

	useEffect(() => {
		if (!open || !itemId) {
			setChatMessages([]);
			return;
		}
		setChatMessages([]);
		loadChatMessages();
	}, [open, itemId, loadChatMessages]);

	return useMemo(
		() => ({
			chatMessages,
			isChatLoading: isLoading,
			loadChatMessages,
		}),
		[chatMessages, isLoading, loadChatMessages]
	);
};

export default useIdentityCaseChatMessages;
